// extracted by mini-css-extract-plugin
export default {"container":"Empresas_container__dloG1","imagen":"Empresas_imagen__7bTak","fakeLinkButton":"Empresas_fakeLinkButton__UvETd"};